export default __webpack_public_path__ + "static/media/new-copy-icon.bf3c5795.svg";